
import { updateAppConfig } from '#app'
import { defuFn } from '/home/firethewall/MSBNET/projeto_OO/OO-Administrador/node_modules/defu/dist/defu.mjs'

const inlineConfig = {
  "nuxt": {
    "buildId": "d84969b3-88d0-4e18-a3a5-27c86c4dbf28"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /* #__PURE__ */ defuFn(inlineConfig)
